import React from "react";
import Navbar from "../components/Navbar";
import COLORS from "../constants/colors";
import "./Contact.css";
import logo from "../assets/images/logofinal_1.png";

function Contact() {
  return (
    <div className="contact-page" style={{
      "--primary": COLORS.secondary,
      "--secondary": COLORS.primary,
      "--secondary-hover": COLORS.primary_hover,
    } as React.CSSProperties}>
      <Navbar />

      <div className="contact-container">
        <img
          src={logo}
          alt="Gmail"
          style={{ width: "40%", height: "auto", marginBottom: "10px" }}
        />
        <p>Bonjour, c’est mon site et il y a des choses.</p>
        <p className="contact-text">
          Mon contact :{" "}
          <a
            href="mailto:oscarmaso123@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "var(--primary)", fontWeight: "bold", textDecoration: "none" }}
          >
            oscarmaso123@gmail.com
          </a>
        </p>
      </div>
    </div>
  );
}

export default Contact;
